import * as React from "react";
import Typography from "@mui/material/Typography";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import IconButton from "@mui/material/IconButton";
import Tooltip,  { tooltipClasses } from '@mui/material/Tooltip';

function copyWithExecCommand(text) {
  return new Promise((resolve, reject) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.setAttribute("readonly", "");
    textArea.style.position = "fixed";
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.opacity = "0";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    textArea.setSelectionRange(0, text.length);
    try {
      const ok = document.execCommand("copy");
      document.body.removeChild(textArea);
      if (ok) {
        resolve();
      } else {
        reject(new Error("copy failed"));
      }
    } catch (err) {
      document.body.removeChild(textArea);
      reject(err);
    }
  });
}

/** Clipboard API is blocked in cross-origin iframes unless parent sets allow="clipboard-write". */
function canUseClipboardApi() {
  if (!navigator.clipboard || !window.isSecureContext) {
    return false;
  }
  if (window.self !== window.top) {
    return false;
  }
  if (
    typeof document.permissionsPolicy !== "undefined" &&
    typeof document.permissionsPolicy.allowsFeature === "function" &&
    !document.permissionsPolicy.allowsFeature("clipboard-write")
  ) {
    return false;
  }
  return true;
}

async function copyTextToClipboard(text) {
  if (canUseClipboardApi()) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch {
      // Fall through to execCommand (e.g. transient permission errors).
    }
  }
  return copyWithExecCommand(text);
}

const LeadIdCopyButton = ({ leadId, onCopySuccess, onCopyError, styl }) => {
  const handleClick = async (event) => {
    event.preventDefault();
    event.stopPropagation();
    try {
      await copyTextToClipboard(String(leadId));
      onCopySuccess?.();
    } catch {
      onCopyError?.();
    }
  };

  return (
      <Tooltip title="Copy Lead Id">
     <IconButton
     type="button"
      className={`lead-id-copy`}
      onClick={handleClick}
      aria-label="Copy Lead ID"
      sx={{ 
          backgroundColor: styl?.bg,
          color: styl?.text
        }}
    >
        <Typography component="span" variant="span" className="lead-id-copy__label">
          Lead ID
        </Typography>
      <ContentCopyIcon className="lead-id-copy__icon" />
    </IconButton>
    </Tooltip>
  );
};

export default LeadIdCopyButton;
